var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation-bar',{attrs:{"router":_vm.$router}}),_c('hero-section'),_c('features-section'),_c('how-it-works-section'),_c('demo-section'),_c('pricing-section'),_c('contact-section'),_c('footer-section'),_c('floating-whatsapp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }